import { render, staticRenderFns } from "./RatesSection.vue?vue&type=template&id=1e2d24e1&scoped=true&"
import script from "./RatesSection.vue?vue&type=script&lang=js&"
export * from "./RatesSection.vue?vue&type=script&lang=js&"
import style0 from "./RatesSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RatesSection.vue?vue&type=style&index=1&id=1e2d24e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d24e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VContainer,VDivider,VImg,VRow})
